













































import { defineComponent } from '@vue/composition-api';
import { show, title, message, callback, positiveText, negativeText } from './state';

export default defineComponent({
  name: 'Prompt',
  setup() {
    function clickPositive() {
      if (callback.value) {
        // resolve callback to return true
        callback.value(true);
      }
      show.value = false;
    }

    function clickNegative() {
      if (callback.value) {
        // resolve callback to return false
        callback.value(false);
      }
      show.value = false;
    }

    return {
      show,
      title,
      message,
      positiveText,
      negativeText,
      clickPositive,
      clickNegative,
    };
  },
});
